import { apiClient } from "../client";

export async function dummyDownloadTemplate(payload: { memberId: string; fileId: string }) {
  // This is a dummy POST endpoint for testing download action
  // Replace '/dummy-download' with your actual endpoint if needed
  const response = await apiClient.post("/PDFConvertor/download/file", payload);
  const blob = response?.data;
  if (blob && blob.size > 0) {
    const url = window.URL.createObjectURL(blob);
    // Try to extract filename from Content-Disposition header
    const dispo = (response.headers as Record<string, string | undefined>)["content-disposition"];
    let fileName = `filled-${payload.fileId}.pdf`;
    if (dispo) {
      const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(dispo);
      const name = match?.[1] || match?.[2];
      if (name) fileName = decodeURIComponent(name);
    }
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    return {
      message: `Downloaded ${fileName}`,
      fileId: payload.fileId,
    };
  }
  return {
    message: "Form submitted, but no file received.",
    fileId: payload.fileId,
  }
}

/**
 * Downloads Acro Format PDF
 * Makes a GET request to retrieve the reformed HTML form
 * @param emailId - User's email ID
 * @param memberId - Member ID
 * @param fileId - File ID to download
 * @returns Response with downloaded form data
 */
export async function getAcroFormInfoByMemberId(
  emailId: string,
  memberId: string,
  fileId: string
) {
  try {
    const response = await apiClient.get(
      `/PDFConvertor/reformed/html/forms/${emailId}/${memberId}`,
      {
        params: {
          fileId: fileId,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error downloading Acro form template:", error);
    throw error;
  }
}

export async function downloadAcroFormTemplate(
  emailId: string,
  memberId: string,
  fileId: string
) {
  try {
    const response = await apiClient.get(
      `/PDFConvertor/reformed/html/forms/${emailId}/${memberId}`,
      {
        params: {
          fileId: fileId,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error downloading Acro form template:", error);
    throw error;
  }
}
